export default __webpack_public_path__ + "assets/images/225ee488f3278b9089f1ad2dc9e290bc.jpg";